import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Stack,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  FormControlLabel,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { alpha } from '@mui/material/styles';
import AppNavbar from '../../../components/AppNavbar';
import Header from '../../../components/Header';
import SideMenu from '../../../components/SideMenu';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from '../../dashboard/theme/customizations';
import AppTheme from '../../../shared-theme/AppTheme';
import { Add, CheckCircle, DragIndicator, RemoveCircleOutline, Category, TrendingUp, Assessment, Inventory } from '@mui/icons-material';
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { tiposCampos,catInventarioCamposObligatorios,catInventarioGenericoCamposObligatorios } from '../../../utils/staticvariables';
import InventarioTypeSelector from './components/inventarioTypeSelector';
import { fetchCategorias } from '../../../utils/generalsFetch';
import EditarCategoria from './editarCategoria';
import AccessDeniedBox from '../../../components/AccessDeniedBox';
import EmptyState from '../../../components/EmptyState';
import { useTourContext } from '../../../components/TourProvider';



const SortableItem = ({ field, categoriaId, onChange, onRemove,handleKeyDown, handleRemoveOption }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
    } = useSortable({ id: field.id });
  
    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      border: '1px solid #e0e0e0',
      borderRadius: 8,
      padding: 16,
      backgroundColor: '#fff',
      marginBottom: 16,
    };
    
    if(field==undefined) {
      return;
      }
  
    return (
      <Box ref={setNodeRef} style={style} {...attributes}>
          <Box display="flex" alignItems="center">
  
              <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
              <IconButton {...listeners}>
                  <DragIndicator/>
              </IconButton>
  
  
                  <TextField
                      disabled={!field.deletelable}
                      value={field.name}
                      onChange={(e) => onChange(categoriaId, field.id, 'name', e.target.value)}
                      placeholder="Nombre del campo"
                      sx={{width:field.id=='id' ? 50 : 300}}
                  />
                  { field.id=='id' && (
                      <TextField
                      value={field.alias}
                      onChange={(e) => onChange(categoriaId, field.id, 'alias', e.target.value)}
                      placeholder="Alias del campo"
                      sx={{minWidth:200}}
                      />
                  )}
                  { field.id=='id' && (
                      <TextField
                      value={field.prefijo}
                      onChange={(e) => onChange(categoriaId, field.id, 'prefijo', e.target.value)}
                      placeholder="Prefijo"
                      sx={{maxWidth:100}}
                      />
                  )}
                  <Select
                      disabled={!field.deletelable}
                      value={field.type}
                      onChange={(e) => onChange(categoriaId, field.id, 'type', e.target.value)}
                      size="small"
                  >
                    {tiposCampos.map((tipo) => (
                      <MenuItem value={tipo.value}>{tipo.label}</MenuItem>
                    ))}
                  </Select>
                  {field.deletelable !== false && (
                  <IconButton onClick={() => onRemove(categoriaId, field.id)}>
                      <RemoveCircleOutline color="error" />
                  </IconButton>
                      )}  
                  <FormControlLabel
                      disabled={!field.deletelable}
                      control={
                      <Switch
                          checked={field.required || false}
                          onChange={(e) => onChange(categoriaId, field.id, 'required', e.target.checked)}
                      />
                      }
                      label="Requerido"
                  />

              </Box>
          </Box>
          {field.type === 'opciones' && (
          <Box py={1}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
              {field.options.map((opt, idx) => (
                <Box key={idx} sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#e0e7ff', color: '#1e40af', px: 1.5, py: 0.5, borderRadius: 1, fontSize: '0.85rem' }}>
                  {opt}
                  {field.deletelable && (
                  <IconButton onClick={() => handleRemoveOption(categoriaId,field.id, idx)} size="small" sx={{ ml: 0.5 }}>
                    <RemoveCircleOutline sx={{ color: 'red' }} fontSize="small" />
                  </IconButton>
                  )}
                </Box>
              ))}
            </Box>
            {field.deletelable && (
            <TextField
              disabled={!field.deletelable}
              placeholder="Escribe tus opciones y presiona Enter o coma"
              value={field.inputValue}
              onChange={(e) => onChange(categoriaId,field.id, 'inputValue', e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, categoriaId,field.id)}
              fullWidth
              size="small"
            />
            )}
          </Box>
           )}
  
      </Box>
    );
  };
  

const xThemeComponents = {
    ...chartsCustomizations,
    ...dataGridCustomizations,
    ...datePickersCustomizations,
    ...treeViewCustomizations,
  };

const ProductosCategoria = (props) => {
    // Global tour context
    const { startSpecificTour } = useTourContext();
    const [openAgregarCategoria, setOpenAgregarCategoria] = useState(false)
    const [inventarioType, setInventarioType] = useState('serializado')
    const [categorias, setCategorias] = useState([])
    const [editActiveCategoria, setEditActiveCategoria] = useState(null)
    const [accessDenied, setAccessDenied] = React.useState(false);
    const [nuevaCategoria, setnuevaCategoria] = useState([{
        id: Date.now(),
        nombre: '',
        campos: catInventarioCamposObligatorios
      }
    ]);
      const [activeCategoria, setActiveCategoria] = useState(null);
    
      const [errors, setErrors] = useState({});

     // Validation function for add-category form
     const validateFields = () => {
       let newErrors = {};
       if (!nuevaCategoria[0].nombre || nuevaCategoria[0].nombre.trim() === "") {
         newErrors.nombre = "El nombre de la categoría es obligatorio.";
       }
       if (!inventarioType || inventarioType.trim() === "") {
         newErrors.inventarioType = "El tipo de inventario es obligatorio.";
       }
       // At least one custom field
       if (!nuevaCategoria[0].campos || nuevaCategoria[0].campos.length === 0) {
         newErrors.campos = "Debe agregar al menos un campo personalizado.";
       } else {
         // Check for empty field names
         nuevaCategoria[0].campos.forEach((campo, idx) => {
           if (!campo.name || campo.name.trim() === "") {
             newErrors[`campo_${idx}`] = "El nombre del campo es obligatorio.";
           }
         });
       }
       setErrors(newErrors);
       return Object.keys(newErrors).length === 0;
     };
    
      useEffect(() => {

        fetchCategorias({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') }).then(data => {
          setCategorias(data)
        }).catch((error) => {
          setAccessDenied(true);
        })

        
        setnuevaCategoria(prev =>
          prev.map(cat => {
            const hasId = cat.campos?.some(c => c.id === 'id');
            return hasId ? cat : {
              ...cat,
              campos: [
              catInventarioCamposObligatorios.map((e)=>e)            , ...(cat.campos || [])]
            };
          })
        );
      }, []);

      useEffect(() => {

        if(inventarioType == 'Generico') {
          setnuevaCategoria(prev =>
            prev.map(cat => ({ ...cat, campos: catInventarioGenericoCamposObligatorios }))
          );
        }
        else {
          setnuevaCategoria(prev =>
            prev.map(cat => ({ ...cat, campos: catInventarioCamposObligatorios }))
          );
        }
      }, [inventarioType]);


      async function postCategoria() {
        if (!validateFields()) {
          return;
        }
        const url = `${process.env.REACT_APP_SERVER_URL}/api/categorias`;
        try {
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
            },
            body: JSON.stringify({
              idcompany:localStorage.getItem('idcompany'),
              nombre:nuevaCategoria[0].nombre,
              tipo:inventarioType,
              campos: nuevaCategoria[0].campos,
              created_by: localStorage.getItem('id')
            })
          });
      
          if (!response.ok) {
            const error = await response.json();
            setErrors(prev => ({...prev, general: error.error || 'Error al crear categoría'}));
            throw new Error(error.error || 'Error al crear categoría');
          }
          setOpenAgregarCategoria(false)
        } catch (error) {
          setErrors(prev => ({...prev, general: error.message || 'Error desconocido'}));
          throw error;
        }
      }
      


      const handleFieldChange = (catId, fieldId, key, value) => {
        setnuevaCategoria(prev =>
          prev.map(cat =>
            cat.id === catId
              ? {
                  ...cat,
                  campos: cat.campos.map(campo =>
                    campo.id === fieldId ? { ...campo, [key]: value } : campo
                  )
                }
              : cat
          )
        );
      };
    
      const handleAddField = (catId) => {
        setnuevaCategoria(prev =>
          prev.map(cat =>
            cat.id === catId
              ? {
                  ...cat,
                  campos: [
                    ...cat.campos,
                    {
                      id: Date.now(),
                      name: '',
                      type: 'texto',
                      required: false,
                      options: [],
                      alias:'',prefijo:'',deletelable: true,
                      inputValue: ''
                    }
                  ]
                }
              : cat
          )
        );
      };
    
      
    
      const handleRemoveField = (catId, fieldId) => {
        setnuevaCategoria(prev =>
          prev.map(cat =>
            cat.id === catId
              ? {
                  ...cat,
                  campos: cat.campos.filter(campo => campo.id !== fieldId)
                }
              : cat
          )
        );
      };
      const handleKeyDown = (e, categoria,id) => {
        if (e.key === 'Enter' || e.key === ',') {
          e.preventDefault();
          handleAddOption(categoria,id);
        }
      };
    
      const handleAddOption = (categoriaId, fieldId) => {
        setnuevaCategoria(prev =>
          prev.map(cat =>
            cat.id === categoriaId
              ? {
                  ...cat,
                  campos: cat.campos.map(field =>{
                    console.log("field",field);
                    const newOption = field.inputValue.trim();
                    if (!newOption) return field;        
                    if(field.id === fieldId){
                        return {
                          ...field,
                          options: [...(field.options || []),  newOption]
                        };
                        }
                    return field
                    }
                  )
                }
              : cat
          )
        );
      };
    
      const handleRemoveOption = (categoriaId, fieldId, optionIndex) => {
        setnuevaCategoria(prev =>
          prev.map(cat =>
            cat.id === categoriaId
              ? {
                  ...cat,
                  campos: cat.campos.map(field =>
                    field.id === fieldId
                      ? {
                          ...field,
                          options: field.options.filter((_, index) => index !== optionIndex)
                        }
                      : field
                  )
                }
              : cat
          )
        );
      };
      
    
      const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!active || !over || active.id === over.id || !activeCategoria) return;
    
        const currentCat = nuevaCategoria.find(c => c.id === activeCategoria);
        if (!currentCat) return;
    
        const oldIndex = currentCat.campos.findIndex(f => f.id === active.id);
        const newIndex = currentCat.campos.findIndex(f => f.id === over.id);
    
        const newCampos = arrayMove(currentCat.campos, oldIndex, newIndex);
    
        setnuevaCategoria(prev =>
          prev.map(cat =>
            cat.id === activeCategoria ? { ...cat, campos: newCampos } : cat
          )
        );
      };
    
    
    
  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
    <CssBaseline enableColorScheme />
        <Box sx={{ display: 'flex' }}>
            <SideMenu />
            <AppNavbar />
            {/* Main content */}
            <Box
            component="main"
            sx={(theme) => ({
                flexGrow: 1,
                backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
                overflow: 'auto',
            })}
            >
            <Stack
                spacing={2}
                sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
                }}
            >
                    <Header 
                      parent={"Logistica y Almacenes"} 
                      child={"Categorias"}
                      onStartTour={startSpecificTour}
                    />

                    <Box sx={{ fontFamily: 'Inter, Noto Sans, sans-serif', bgcolor: 'white'}}>
                        <Container maxWidth="xl">
                            {!accessDenied ? 
                            <Grid container mt={4}>
                                <Grid item size={(editActiveCategoria) || openAgregarCategoria ? 6 : 12}>
                                    <Box display="flex"  px={2}>
                                        <Typography variant="h4" fontWeight="bold">Categorías de Productos</Typography>
                                        <Button variant="contained" startIcon={<Add/>} color='primarybutton' sx={{marginLeft:10, fontWeight:"bold" }} onClick={()=>{setOpenAgregarCategoria(true);setActiveCategoria(null)}} data-tour="boton-agregar-categoria">Agregar categoría</Button>
                                    </Box>
                                    {categorias.length > 0  ? (
                                    <Box data-tour="categorias-existentes">
                                      <Typography variant="h6" fontWeight="bold" mt={4} px={2}>Categorías Existentes</Typography>
                                      {categorias.map((cat) => (
                                      <Box key={cat.value} display="flex" justifyContent="space-between" alignItems="center" px={2} py={1} borderBottom="1px solid #f1f2f4">
                                          <Box>
                                              <Typography fontWeight="medium">{cat.label}</Typography>
                                          </Box>
                                          <Box>
                                              <IconButton onClick={()=>{setEditActiveCategoria(cat);setOpenAgregarCategoria(false)}}>
                                                  <ArrowDropDownIcon />
                                              </IconButton>
                                              <IconButton onClick={()=>{setOpenAgregarCategoria(true)}}>
                                                  <RemoveCircleOutline sx={{color:"red"}}/>
                                              </IconButton>
                                          </Box>
                                      </Box>
                                      ))}
                                    </Box>
                                    )
                                    :
                                    <EmptyState 
                                        icon={Category}
                                        title="No hay categorías de productos"
                                        description="Comienza creando tu primera categoría de productos para organizar y gestionar tu inventario de manera eficiente y estructurada."
                                        features={[
                                            {
                                                icon: Inventory,
                                                title: "Organización de Inventario",
                                                description: "Clasifica productos por categorías personalizadas"
                                            },
                                            {
                                                icon: TrendingUp,
                                                title: "Campos Personalizados",
                                                description: "Define campos específicos para cada categoría"
                                            },
                                            {
                                                icon: Assessment,
                                                title: "Reportes por Categoría",
                                                description: "Análisis detallado por tipo de producto"
                                            }
                                        ]}
                                        buttonText="Crear Primera Categoría"
                                        onButtonClick={() => {setOpenAgregarCategoria(true);setActiveCategoria(null)}}
                                        helpText="¿Necesitas ayuda? Contacta a soporte técnico para guiarte en el proceso"
                                    />
                                    }
                                </Grid>

                                {openAgregarCategoria&&
                                <Grid item size={6} sx={{ borderLeft: '1px solid #e0e0e0', pl: { xs: 0, sm: 4 }, mt: { xs: 4, sm: 0 } }} data-tour="formulario-agregar-categoria">
                                    <Typography variant="h5" fontWeight="bold" px={2}>Agregar Categoría</Typography>
                                    <Box px={4} py={2}>
                                      <TextField 
                                        fullWidth 
                                        placeholder="Nombre de la categoría" 
                                        variant="outlined" 
                                        sx={{ mb: 2 }} 
                                        value={nuevaCategoria[0].nombre} 
                                        onChange={(e)=>{setnuevaCategoria(prev=>prev.map(cat=>cat.id===nuevaCategoria[0].id?{...cat,nombre:e.target.value}:cat))}}
                                        error={!!errors.nombre}
                                        helperText={errors.nombre}
                                      />
                                      <InventarioTypeSelector
                                        onChange={(value) => setInventarioType(value)}
                                        optionLabels={["Serializado", "Generico"]}
                                        error={!!errors.inventarioType}
                                      />
                                      {errors.inventarioType && (
                                        <Typography color="error" variant="body2">{errors.inventarioType}</Typography>
                                      )}
                                      <Typography variant="h6" fontWeight="bold" textAlign={"left"} mt={2}>Campos Personalizados</Typography>
                                      {errors.campos && (
                                        <Typography color="error" variant="body2">{errors.campos}</Typography>
                                      )}
                                      {nuevaCategoria.map((cat, index) => (

                                      <Box mt={2} data-tour="campos-personalizados">
                                          <DndContext
                                              collisionDetection={closestCenter}
                                              onDragStart={({ active }) => setActiveCategoria(cat.id)}
                                              onDragEnd={handleDragEnd}
                                          >
                                              <SortableContext
                                              items={cat.campos.map(f => f.id)}
                                              strategy={verticalListSortingStrategy}
                                              >
                                              {cat.campos.map((field, idx) => (
                                                <SortableItem
                                                  key={field.id}
                                                  field={field}
                                                  categoriaId={cat.id}
                                                  onChange={handleFieldChange}
                                                  onRemove={handleRemoveField}
                                                  handleKeyDown={handleKeyDown}
                                                  handleRemoveOption={handleRemoveOption}
                                                  error={errors[`campo_${idx}`]}
                                                />
                                              ))}
                                              </SortableContext>
                                          </DndContext>

                                          <Button startIcon={<Add/>} onClick={() => handleAddField(cat.id)} variant="outlined" sx={{ mt: 2 }}>
                                              Agregar campo
                                          </Button>

                                      </Box>
                                      ))}
                                      <Box display={"flex"} flexDirection={"row"} mt={2} data-tour="acciones-categoria">
                                          {errors.general && (
                                            <Typography color="error" variant="body2" sx={{ mb: 1 }}>{errors.general}</Typography>
                                          )}
                                          <Button variant='outlined' fullWidth onClick={()=>{setOpenAgregarCategoria(false)}}>Cancelar</Button>
                                          <Button fullWidth variant="contained" color='primarybutton' sx={{fontWeight:"bold", marginLeft:2}} onClick={()=>{postCategoria()}}>Guardar Categoría</Button>
                                      </Box>
                                    </Box>
                                </Grid>
                                }
                                {editActiveCategoria && (
                                  <Grid item size={6} sx={{ borderLeft: '1px solid #e0e0e0', pl: { xs: 0, sm: 4 }, mt: { xs: 4, sm: 0 } }}>
                                    <EditarCategoria categoria={editActiveCategoria} onCancel={()=>{setEditActiveCategoria(null)}}/>
                                  </Grid>
                                )}
                            </Grid>
                            :
                            <Box>
                              <br></br>
                              <br></br>
                              <AccessDeniedBox
                                title={'Acceso denegado'}
                                message={'No tienes permisos para ver esta sección de Categorías. Contacta a tu administrador para solicitar acceso o verifica tus roles y permisos.'}
                              />
                            </Box>
                            }
                        </Container>
                    </Box>
                </Stack>
            </Box>
        </Box>
    </AppTheme>
  );
};

export default ProductosCategoria;

